import { IDeductionRepository, ISendForApprovalRepositoryParams } from "@/core/repositories/deduction";

export class SendForApprovalUseCase {
  constructor(private readonly deductionRepository: IDeductionRepository) {}

  async single(params: ISendForApprovalRepositoryParams, currentPage: number) {
    const response = await this.deductionRepository.sendForApproval(params, currentPage);

    return response;
  }

  async bulk(params: ISendForApprovalRepositoryParams[], currentPage: number) {
    const response = await this.deductionRepository.sendForApprovalBulk(params, currentPage);

    return response;
  }
}